module.exports = __webpack_public_path__ + "img/pic-04.f0678458.png";